/**
 * Provides high-fidelity logging for Mission Control.
 */
import { telemetry } from '../spatial/utils/telemetry';

export const ForensicLogger = {
    log: (event: string, metadata: any) => {
        telemetry.log({
            subsystem: 'FORENSIC_SERVICE',
            event: event.toUpperCase().replace(/\s+/g, '_'),
            level: 'FORENSIC',
            payload: metadata
        });

        // Integrate with OpenTelemetry if available
        if (typeof window !== 'undefined' && (window as any).WingmanTraceRecorder) {
            (window as any).WingmanTraceRecorder.recordDecision(
                `Forensic Event: ${event}`,
                null,
                metadata
            );
        }
    }
};

if (typeof window !== 'undefined') {
    (window as any).ForensicLogger = ForensicLogger;
}
